import { render, staticRenderFns } from "./SubmissionsButton.vue?vue&type=template&id=12fb5c29&"
import script from "./SubmissionsButton.vue?vue&type=script&lang=js&"
export * from "./SubmissionsButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports